import React from "react";
import Logo from "./Logo";

export default function Header() {
  return (
    <header
      className="fixed top-0 left-1/2 -translate-x-1/2 w-full max-w-[430px] z-40 bg-[#2b3134]/90 backdrop-blur-lg border-b border-white/5 safe-top"
      data-testid="app-header"
    >
      <div className="h-14 flex items-center justify-center">
        <Logo />
      </div>
    </header>
  );
}
